<template lang="pug">
	.matrix.matrix(@click="emit")
		.matrix-inner
			matrix-loader(v-if="status === null")
			.error(v-else-if="status === false") Whoops, something went wrong.
			router-view(v-else-if="status === true")
</template>

<script>
import Loader from "@/globals/Loader";
import { Header } from "@/matrix/events";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Matrix",
  components: {
    matrixLoader: Loader
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["status", "authorized"])
  },
  methods: {
    ...mapActions(["initialize"]),
    emit() {
      if (this.status) {
        Header.$emit("TOGGLED", null);
      }
    }
  },
  async created() {
		let id = document.querySelector('#tableId').value
		let edit = document.querySelector('#editMode')

		if (edit && edit.value.toLowerCase() === 'true') edit = true
		else edit = false
		
    await this.initialize({id, edit});
  }
};
</script>


<style lang="scss">
.matrix {
  width: 100%;
  min-height: 80vh;
  margin: 3rem auto 1.5rem;
  position: relative;
}

.matrix-inner {
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
}
</style>